import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const LocationIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 200 200" {...rest} __css={styles}>
      <desc id="svgdescLocationIcon">pin drop symbol</desc>
      <circle cx="100" cy="100" r="84.34" className="background" />
      <path
        d="M101.48 101.1a15.71 15.71 0 1 1 15.71-15.71 15.71 15.71 0 0 1-15.71 15.71m0-46.58a30.86 30.86 0 0 0-25.89 47.69l25.89 44.85 25.89-44.85a30.88 30.88 0 0 0-25.89-47.69"
        className="accent"
      />
    </Icon>
  );
};

export default LocationIcon;
